export const RENEWAL_ONE_TYPE = 'renewal-one';
export const WELCOME_TYPE = 'welcome';
export const PAYMENT_ERROR_TYPE = 'payment_error';
export const PAYMENT_RECEIPT_TYPE = 'payment_receipt';

export const EMAIL_KEYMAP = {
	[RENEWAL_ONE_TYPE]: 'Renewal Reminder Email',
	[WELCOME_TYPE]: 'Welcome Email',
	[PAYMENT_ERROR_TYPE]: 'Payment Error Email',
	[PAYMENT_RECEIPT_TYPE]: 'Payment Receipt'
};

export const DEFAULT_EMAIL_FORM_VALUES = {
	email_type: '',
	email_subject: '',
	frequency: 90,
	email_body: '',
	memberemailformcc_set: []
};
